var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-question-marker",on:{"click":_vm.setSelectedItem}},[_c('div',{staticClass:"inner-border"}),_c('p',{on:{"click":_vm.addFormQuestion}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" "+_vm._s(_vm._f("translate")('forms.addQuestion'))+" ")]),_c('create-question-modal',{attrs:{"fromGroup":_vm.fromGroup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }